import React, { Component } from "react";
import { InputNumber } from "antd";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "../../wallet.css";
import "./transferir.css";
import NovoFavorecido from "./novoFavorecido";
import ListaFavoritos from "./listaFavoritos";
import { connect } from 'react-redux'
import { loadBrlBalance } from "../../../../redux-flow/actions/wallet_brl";

class Transferir extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabAtiva: "novo",
            value: 0,
        };
    }

    onClickTab = (id) => {
        if (this.state.tabAtiva != id) {
            this.setState({ tabAtiva: id });
        }
    };

    currencyFormatter = (e) => {
        var tmp = e + "";
        tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
        if (tmp.length > 6) tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

        return tmp;
    };

    handleChange = (e) => {
        this.setState({
            value: e
        })
    }

    componentDidMount() {
        const { onLoad, userid } = this.props
        if(onLoad && userid) {
            onLoad(userid)
        }
    }

    render() {
        const { cashOutMessage, cashSuccess, brlBalance, cashOutError } = this.props
        return (
        <>
            <div>
                <Col md={12}>
                <label className="tx-grey">Você está utilizando este serviço na fase de testes com algumas limitações:<br /><br />-No momento só é possível realizar 1 (uma) transferência por dia, via TED.<br /><br />-O limite mínimo para transferência é de R$20,00 e o máximo é de R$1.000,00/dia e R$5.000,00/semana.</label>
                </Col>
                    <Row className="pl-3 pr-3">
                        <Col md={12}>
                            {!cashSuccess && cashOutMessage === 'Limite diário ultrapassado.' || cashOutMessage === 'Ação fora do horário de retirada.' || cashOutMessage === 'Só é possível realizar TEDs de até R$1000,00.' || cashOutMessage === 'Limite diário excedido' || cashOutMessage === 'Falha interna' ?
                                <div class="alert alert-danger fade show " role="alert" style={{width: '100%'}}>
                                    <center><label className="mb-0">{cashOutMessage}</label></center>
                                </div> : ''
                            }
                        </Col>
                        <Col md={6} className="mt-3 d-flex flex-column justify-content-end">
                            <label className="titulosTransferir mb-2 p-0">Informe o valor</label>

                            <div className="divInputValor">
                                <label className="moeda">R$</label>

                                <InputNumber
                                    className="inputValor"
                                    formatter={(value) => this.currencyFormatter(value)}
                                    max={100000}
                                    parser={(value) => String(value).replace(/\D/g, "")}
                                    style={{ width: "100%" }}
                                    value={this.state.value}
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </div>
                            {!cashSuccess && cashOutMessage === 'Valor de retirada fora do limite permitido' ? <small style={{color: 'red'}}>Valor de retirada fora do limite permitido</small> : ''}
                            {!cashSuccess && cashOutMessage === 'Saldo insuficiente' ? <small style={{color: 'red'}}>Saldo insuficiente</small> : ''}
                            {!cashSuccess && cashOutError === 'value' ? <small style={{color: 'red'}}>Insira um valor válido</small> : ''}
                            {!cashSuccess && cashOutError === 'size' ? <small style={{color: 'red'}}>O valor mínimo de transferência deve ser superior a R$20,00</small> : ''}
                        </Col>

                        <Col md={6} className="mt-3">
                            <div className="d-flex flex-column justify-content-center align-items-center saldoWrapper">
                                <label className="tx-gray mb-0">Tarifa de transferência</label>
                                <label className="tx-pink mb-0">R$2,50</label>
                            </div>
                        </Col>
                    </Row>
                <Col md={12}>
                    <label className="titulosTransferir mt-5 mb-2">Favorecido</label>
                </Col>

                {/* <Col md={6}>
                    <div className="divTipoFavorecido mt-1">
                        <Col md={3} className="p-0 mr-1">
                            <div
                                id="novo"
                                className={`tabFav ${ this.state.tabAtiva == "novo" ? "tabFavActive" : ""}`}
                                onClick={() => this.onClickTab("novo")}
                            >
                                <label className="nomeTabTransf">Novo</label>
                            </div>
                        </Col>

                        <Col md={3} className="p-0 ml-1">
                            <div
                                id="favoritos"
                                className={`tabFav ${ this.state.tabAtiva == "favoritos" ? "tabFavActive" : ""}`}
                                onClick={() => this.onClickTab("favoritos")}
                            >
                                <label className="nomeTabTransf">Favoritos</label>
                            </div>
                        </Col>
                    </div>
                </Col> */}

                <Col md={12} className="mt-4">
                    {this.state.tabAtiva == "novo" ? (
                        <NovoFavorecido balance={brlBalance} value={this.state.value} />
                        ) : (
                        <ListaFavoritos
                            isLoading={this.props.isLoading}
                            favorites={this.props.favorites}
                            value={this.state.value}
                        />
                    )}
                </Col>
            </div>
        </>
        );
    }
}

const mapStateToProps = state => ({
    cashSuccess: state.wallet_brl.cashOutSuccess,
    cashOutMessage: state.wallet_brl.cashOutMessage,
    userid: state.login.userid,
    brlBalance: state.wallet_brl.brlBalance,
    cashOutError: state.wallet_brl.cashOutError,
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(loadBrlBalance(id))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(Transferir);
